export default __webpack_public_path__ + "static/media/POLITUR_TRANSFER.fcb71684.webp";